document.addEventListener("DOMContentLoaded", function() {
    var menuDrawer = document.querySelector('.menu-drawer-container');
    var videoContent = document.querySelector('.video-banner .content');

    if (menuDrawer && videoContent) {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (menuDrawer.classList.contains("menu-opening")) {
                    videoContent.style.display = "none";
                } else {
                    videoContent.style.display = "";
                }
            });
        });

        observer.observe(menuDrawer, { attributes: true, attributeFilter: ["class"] });
    }
});
